import {Component, OnInit} from '@angular/core';
import {UIRouter} from '@uirouter/angular';
import {RoutePrefix} from '../shared/route-prefix';
import {FilterParam} from '@ngx-ivengi/crud/request-params';
import {Building} from './building.model';

@Component({
  selector: 'app-building-contact-form',
  templateUrl: './building-contact-form.component.html'
})
export class BuildingContactFormComponent implements OnInit {

  public routePrefix: RoutePrefix;
  public contactFilter: FilterParam;

  constructor(
    private router: UIRouter
  ) {}

  public ngOnInit(): void {
    this.routePrefix = {
      entity: Building.name,
      entityId: this.router.stateService.params.buildingId
    };

    this.contactFilter = {
      id: 0,
      key: 'roles',
      operator: 'eq',
      value: 'PROJECTMANAGER',
      filterFn: 'substringof',
      filterOutcome: 'true'
    };
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/building/building-contact-form.component.ts